'use strict';

var $siteHeader = $('.js-site-header'),
	$mobileTrigger = $siteHeader.find('.js-mobile-trigger'),
	$body = $('body'),
    activeMobileClass = 'is-active-mobile-menu',
    siteMenu = document.querySelector('.site-menu'),
    $jsSiteMenu = $('.js-site-menu'),
    $panels = $('.site-menu__panels-wrapper'),
    $exitBanner = $('.mega-menu__exit'),
    isMobileMenuShown = false,
    toggleMobileMenu;


toggleMobileMenu  = function() {
    if(isMobileMenuShown){
        $body
            .removeClass(activeMobileClass)
            .css('height', '' );

        $panels.removeClass('site-menu__panels-wrapper--visible');
        $jsSiteMenu.css('transform','translateX(0)');
        if ($exitBanner.hasClass('is-visible')) {
            $exitBanner.removeClass('is-visible');
        }
        isMobileMenuShown = false;
    } else {
        $body
            .addClass(activeMobileClass)
            .css('height', parseInt( window.innerHeight, 10) );
        $panels.addClass('site-menu__panels-wrapper--visible');


        isMobileMenuShown = true;
    }
};

$mobileTrigger.on('click', function (ev) {
    var searchInputClass = '.site-search-input';

    ev.preventDefault();

    toggleMobileMenu();
    
    if (siteMenu) {
        siteMenu.querySelector(searchInputClass).style.display = 'block';
    }
});